import Head from "next/head";
import React from "react";

type OgImageProps = {
  src: string;
};
const OgImage = (props: OgImageProps) => {
  const { src } = props;

  if (!src) {
    return null;
  }

  return (
    <Head>
      <meta property="og:image" content={src} key="ogImage" />
      <meta name="twitter:image" content={src} key="twitterImg" />
    </Head>
  );
};

export default OgImage;
